import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {selectOption} from '../../actionCreators/selectOption';
import RomanianPackage from '../../languages/RomanianPackage';
import './Sidemenu.css';

class Submenu extends React.Component {

    constructor () {

        super();

        this.state = {
            hidden: true
        }
    }

    render() {

        const option = this.props.option;

        return (
            <ul 
                key = {option.id}
                className = {this.props.permission ? 'show' : 'hide'}
            >
                <li 
                    onClick={() => this.props.selectOption(option)}
                    className = {this.props.view && this.props.view.defaultName === option.defaultName ? 'active' : '' }
                >
                    {option.icon} {RomanianPackage[option.defaultName]}
                </li>
            </ul>
        )
    }
}

function mapStateToProps(state) {
    return {
        sidemenu: state.sidemenu,
        view: state.activeOption
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        selectOption: selectOption
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Submenu);


// WEBPACK FOOTER //
// ./src/containers/sidemenu/NoSubmenu.js